import React, { Component } from "react";

class FilterComponent extends Component {
    render() {
        console.log("filter components......",this.props)
        return (
            <>
                <input
                    className="cus-filter-input"
                    id="search"
                    type="text"
                    placeholder="Filter"
                    aria-label="Search Input"
                    value={this.props.filterText}
                    onChange={this.props.onFilter}
                />
                <button
                   onClick={this.props.onFilterValue}>
                     Submit
                </button>
            </>
        );
    }
}
export default FilterComponent;